import {
    BarDataSubscriptionDataItem,
    HistoricalBarDataItemBar,
    PriceDataItem,
} from '@instinet-bcng/sidecar-client';
import { BarData, TickData } from 'marketData/store/marketDataSlice';

export function toTickItem(symbol: string, item: PriceDataItem): TickData {
    const { bid, ask, last, high, time, volume, low } = item;
    return {
        symbol,
        time: new Date(time).getTime(),
        bid,
        ask,
        lastPrice: last,
        volume,
        high,
        low,
    };
}

export function toBarItem(
    symbol: string,
    item: BarDataSubscriptionDataItem,
    binSize: number
): BarData {
    const { low, volume, high, time, open, close } = item;

    return {
        symbol,
        high,
        low,
        volume,
        open,
        time,
        binSize,
        close,
    };
}

export function historicalBarItemToBarData(
    symbol: string,
    barSize: number,
    item: HistoricalBarDataItemBar
): BarData {
    const { low, volume, high, time, open, close } = item;

    return {
        symbol,
        binSize: barSize,
        close,
        high,
        time: new Date(time).getTime(),
        open,
        volume,
        low,
    };
}

export function barDataSubscriptionItemToBarData(
    symbol: string,
    item: BarDataSubscriptionDataItem,
    binSize: number
): BarData {
    const { low, volume, high, time, open, close } = item;

    return {
        symbol,
        binSize,
        close,
        high,
        time: new Date(time).getTime(),
        open,
        volume,
        low,
    };
}
